import { applyMiddleware, createStore } from 'redux'
import promise from 'redux-promise'
import { createLogger } from 'redux-logger'
import ReduxThunk from 'redux-thunk'
import rootReducer from './index'

export default () => {
  return createStore(
    rootReducer,
    applyMiddleware(promise, ReduxThunk, createLogger())
  )
}



// WEBPACK FOOTER //
// ./src/Redux/createStore.js